<template>
<div>
  <v-row no-gutters justify="center" class="pt-3" style="height:196px;" v-show="isLoading">
    <div class="donutSpinner"></div>
  </v-row>
  <div v-show="!isLoading">
    <v-row no-gutters class="mx-4">
      <div id="admin-notification" class="admin-notification"/>
      <div class="mt-5 d-flex align-center">
        <span style="color: #000000;font-size:X-large;font-weight:bold;display: inline-block;width:270px;">{{ isShowMonthly ? targetUriageYm : targetUriagePeriod }}の実績推移</span>
        <span class="ml-2" />
      </div>
      <div class="mt-5 d-flex align-center">
        <v-chip color="#0070C0" class="switch-btn" label dark :outlined="!isShowMonthly" @click="isShowMonthly = true">月間推移</v-chip>
        <v-chip color="#0070C0" class="switch-btn" label dark :outlined="isShowMonthly" @click="isShowMonthly = false">年間推移</v-chip>
      </div>
      <v-spacer />
      <div style="position: relative; top: 12px;">
        <v-checkbox v-model="showChartLabel" label="グラフに値を表示する" />
      </div>
    </v-row>
    <hr class="mx-4" style="padding-top: 0px !important; padding-bottom: 0px !important; margin-top: 4px !important; margin-bottom: 0px !important;" color="#00ffdd" />
    <apexchart
      v-if="isShowMonthly"
      type="line"
      height="350"
      :options="chartOptions"
      :series="chartDataSource"
    />
    <apexchart
      v-else
      type="line"
      height="350"
      :options="chartOptions2"
      :series="chartDataSource2"
    />
  </div>
</div>
</template>
<script>
import flowMixin from '@/mixins/flowMixins'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'DdUriageChartDisp',
  mixins: [flowMixin],
  props: {
    targetYm: String
  },
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    showChartLabel: false,
    chartDataSource: [],
    chartDataSource2: [],
    lastSearchYear: null,
    isShowMonthly: true,
    isLoading: false
  }),
  created () {
  },
  mounted () {
    console.log('Chart')
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    targetUriageYm () {
      if ([undefined, null, ''].includes(this.targetYm)) return
      const dt = this.targetYm.split('/')
      return dt[0] + '年' + dt[1] + '月'
    },
    targetUriagePeriod () {
      if (this.chartDataSource2.length < 1) return
      console.log('targetUriagePeriod', this.chartDataSource2)
      const targetPeriod = this.chartDataSource2[0].data[0].x.split('-')
      return targetPeriod[0] + '年度'
    },
    // 日毎集計用
    chartOptions () {
      return {
        chart: { height: 350, type: 'line' },
        xaxis: {
          type: 'category',
          labels: {
            rotate: -45,
            formatter: function (val) {
              const date = new Date(val)
              const day = date.getDate()
              return `${day}日`
            }
          }
        },
        plotOptions: { bar: { columnWidth: '90%' }, line: { connectNulls: true } },
        stroke: { width: [0, 0, 0, 2, 2], curve: 'straight' },
        title: { },
        tooltip: {
          shared: true,
          intersect: false,
          fixed: {
            enabled: true,
            position: 'topLeft',
            offsetX: 20,
            offsetY: 10
          },
          y: {
            formatter: function (val, { seriesIndex }) {
              const safeVal = val == null ? 0 : val
              if (seriesIndex === 0) return `${(safeVal / 10000).toLocaleString()} 万円`
              if (seriesIndex === 1) return `${(safeVal / 10000).toLocaleString()} 万円`
              if (seriesIndex === 2) return `${(safeVal / 10000).toLocaleString()} 万円`
              if (seriesIndex === 3) return `${safeVal} 件`
              if (seriesIndex === 4) return `${safeVal} 台`
              return safeVal
            }
          }
        },
        dataLabels: {
          enabled: this.showChartLabel,
          enabledOnSeries: [0, 1, 2, 3, 4],
          formatter: function (val, { seriesIndex }) {
            if (val == null || val === 0) return ''

            if (seriesIndex === 0) return `${(Number(val) / 10000).toLocaleString()} 万円`
            if (seriesIndex === 1) return `${(Number(val) / 10000).toLocaleString()} 万円`
            if (seriesIndex === 2) return `${(Number(val) / 10000).toLocaleString()} 万円`
            if (seriesIndex === 3) return `${Number(val).toLocaleString()} 件`
            if (seriesIndex === 4) return `${Number(val).toLocaleString()} 台`
            return val
          }
        },
        yaxis: [
          {
            title: { text: '金額' },
            labels: { formatter: val => `${(val / 10000).toLocaleString()} 万円` },
            // 明示的に支払額を売上と同じ個所に指定（どうもyAxisIndexだけではうまくいかない）
            seriesName: '売上額'
          },
          {
            seriesName: '売上額',
            show: false
          },
          {
            seriesName: '売上額',
            show: false
          },
          {
            opposite: true,
            title: { text: '件数/台数' },
            labels: { formatter: val => `${val.toFixed(0)} 件` },
            // 明示的に支払額を売上と同じ個所に指定（どうもyAxisIndexだけではうまくいかない）
            seriesName: '明細件数'
          },
          {
            seriesName: '明細件数',
            show: false
          }
        ]
      }
    },
    chartOptions2 () {
      return {
        chart: { height: 350, type: 'line' },
        xaxis: {
          type: 'category',
          labels: {
            formatter: function (val) {
              // valが '2025/06/01' の形式である前提
              const date = new Date(val)
              if (isNaN(date)) return val
              const yy = String(date.getFullYear()).slice(2)
              const mm = ('0' + (date.getMonth() + 1)).slice(-2)
              return `'${yy}/${mm}`
            }
          }
        },
        plotOptions: { bar: { columnWidth: '80%' }, line: { connectNulls: true } },
        stroke: { width: [0, 0, 0, 2, 2], curve: 'straight' },
        title: { },
        tooltip: {
          shared: true,
          intersect: false,
          fixed: {
            enabled: true,
            position: 'topLeft',
            offsetX: 20,
            offsetY: 10
          },
          y: {
            formatter: function (val, { seriesIndex }) {
              const safeVal = val == null ? 0 : val
              if (seriesIndex === 0) return `${(safeVal / 10000).toLocaleString()} 万円`
              if (seriesIndex === 1) return `${(safeVal / 10000).toLocaleString()} 万円`
              if (seriesIndex === 2) return `${(safeVal / 10000).toLocaleString()} 万円`
              if (seriesIndex === 3) return `${safeVal} 件`
              if (seriesIndex === 4) return `${safeVal} 台`
              return safeVal
            }
          }
        },
        dataLabels: {
          enabled: this.showChartLabel,
          enabledOnSeries: [0, 1, 2, 3, 4],
          formatter: function (val, { seriesIndex }) {
            if (val == null || val === 0) return ''

            if (seriesIndex === 0) return `${(Number(val) / 10000).toLocaleString()} 万円`
            if (seriesIndex === 1) return `${(Number(val) / 10000).toLocaleString()} 万円`
            if (seriesIndex === 2) return `${(Number(val) / 10000).toLocaleString()} 万円`
            if (seriesIndex === 3) return `${Number(val).toLocaleString()} 件`
            if (seriesIndex === 4) return `${Number(val).toLocaleString()} 台`
            return val
          }
        },
        yaxis: [
          {
            title: { text: '金額' },
            labels: { formatter: val => `${(val / 10000).toLocaleString()} 万円` },
            // 明示的に支払額を売上と同じ個所に指定（どうもyAxisIndexだけではうまくいかない）
            seriesName: '売上額'
          },
          {
            seriesName: '売上額',
            show: false
          },
          {
            seriesName: '売上額',
            show: false
          },
          {
            opposite: true,
            title: { text: '件数/台数' },
            labels: { formatter: val => `${val.toFixed(0)} 件` },
            // 明示的に支払額を売上と同じ個所に指定（どうもyAxisIndexだけではうまくいかない）
            seriesName: '明細件数'
          },
          {
            seriesName: '明細件数',
            show: false
          }
        ]
      }
    }
  },
  methods: {
    searchUriageChartSummary: function (p) {
      this.isLoading = true
      const self = this
      console.log('searchDayByDaySummary')
      const conditions = {
        targetYm: this.targetYm,
        targetYmdType: p
      }
      self.HttpClient.post('/api/v1/VwCD2comd000002/Search', conditions)
        .then((data) => {
          self.dataList = data.payload
          if (p === '01') {
            this.chartDataSource = [
              {
                name: '売上額',
                type: 'column',
                data: self.dataList.map(item => ({
                  x: item.sagyoYoteiYmd,
                  y: item.uriageKingaku
                })),
                color: '#6495ed'
              },
              {
                name: '支払額',
                type: 'column',
                data: self.dataList.map(item => ({
                  x: item.sagyoYoteiYmd,
                  y: item.yoshaShiharaiKingaku
                })),
                color: '#ffb6c1'
              },
              {
                name: '経費',
                type: 'column',
                data: self.dataList.map(item => ({
                  x: item.sagyoYoteiYmd,
                  y: item.keihiKingaku
                })),
                color: '#ff7f50'
              },
              {
                name: '明細件数',
                type: 'line',
                data: self.dataList.map(item => ({
                  x: item.sagyoYoteiYmd,
                  y: item.meisaiCount
                })),
                color: '#696969'
              },
              {
                name: '車両台数（自車＋傭車）',
                type: 'line',
                data: self.dataList.map(item => ({
                  x: item.sagyoYoteiYmd,
                  y: item.unkoCount
                })),
                color: '#ffa500'
              }
            ]
          } else if (p === '02') {
            this.chartDataSource = [
              {
                name: '売上額',
                type: 'column',
                data: self.dataList.map(item => ({
                  x: item.seikyuYoteiYmd,
                  y: item.uriageKingaku
                })),
                color: '#6495ed'
              },
              {
                name: '支払額',
                type: 'column',
                data: self.dataList.map(item => ({
                  x: item.seikyuYoteiYmd,
                  y: item.yoshaShiharaiKingaku
                })),
                color: '#ffb6c1'
              },
              {
                name: '経費',
                type: 'column',
                data: self.dataList.map(item => ({
                  x: item.seikyuYoteiYmd,
                  y: item.keihiKingaku
                })),
                color: '#ff7f50'
              },
              {
                name: '明細件数',
                type: 'line',
                data: self.dataList.map(item => ({
                  x: item.seikyuYoteiYmd,
                  y: item.meisaiCount
                })),
                color: '#696969'
              },
              {
                name: '車両台数（自車＋傭車）',
                type: 'line',
                data: self.dataList.map(item => ({
                  x: item.seikyuYoteiYmd,
                  y: item.unkoCount
                })),
                color: '#ffa500'
              }
            ]
          }

          this.$nextTick(() => {
            const conditions2 = {
              targetYm: this.targetYm,
              targetYmdType: p
            }
            self.HttpClient.post('/api/v1/VwCD2comd000002/AnnualSearch', conditions2)
              .then((data) => {
                self.dataList2 = data.payload
                if (p === '01') {
                  this.chartDataSource2 = [
                    {
                      name: '売上額',
                      type: 'column',
                      data: self.dataList2.map(item => ({
                        x: item.sagyoYoteiYmd,
                        y: item.uriageKingaku
                      })),
                      color: '#6495ed'
                    },
                    {
                      name: '支払額',
                      type: 'column',
                      data: self.dataList2.map(item => ({
                        x: item.sagyoYoteiYmd,
                        y: item.yoshaShiharaiKingaku
                      })),
                      color: '#ffb6c1'
                    },
                    {
                      name: '経費',
                      type: 'column',
                      data: self.dataList2.map(item => ({
                        x: item.sagyoYoteiYmd,
                        y: item.keihiKingaku
                      })),
                      color: '#ff7f50'
                    },
                    {
                      name: '明細件数',
                      type: 'line',
                      data: self.dataList2.map(item => ({
                        x: item.sagyoYoteiYmd,
                        y: item.meisaiCount
                      })),
                      color: '#696969'
                    },
                    {
                      name: '車両台数（自車＋傭車）',
                      type: 'line',
                      data: self.dataList2.map(item => ({
                        x: item.sagyoYoteiYmd,
                        y: item.unkoCount
                      })),
                      color: '#ffa500'
                    }
                  ]
                } else if (p === '02') {
                  this.chartDataSource2 = [
                    {
                      name: '売上額',
                      type: 'column',
                      data: self.dataList2.map(item => ({
                        x: item.seikyuYoteiYmd,
                        y: item.uriageKingaku
                      })),
                      color: '#6495ed'
                    },
                    {
                      name: '支払額',
                      type: 'column',
                      data: self.dataList2.map(item => ({
                        x: item.seikyuYoteiYmd,
                        y: item.yoshaShiharaiKingaku
                      })),
                      color: '#ffb6c1'
                    },
                    {
                      name: '経費',
                      type: 'column',
                      data: self.dataList2.map(item => ({
                        x: item.seikyuYoteiYmd,
                        y: item.keihiKingaku
                      })),
                      color: '#ff7f50'
                    },
                    {
                      name: '明細件数',
                      type: 'line',
                      data: self.dataList2.map(item => ({
                        x: item.seikyuYoteiYmd,
                        y: item.meisaiCount
                      })),
                      color: '#696969'
                    },
                    {
                      name: '車両台数（自車＋傭車）',
                      type: 'line',
                      data: self.dataList2.map(item => ({
                        x: item.seikyuYoteiYmd,
                        y: item.unkoCount
                      })),
                      color: '#ffa500'
                    }
                  ]
                }
                this.lastSearchYear = conditions2.TargetYear
              })
          })
          this.isLoading = false
        })
    }
  }
}
</script>
<style scoped>
.switch-btn {
  margin-top: -6px;
}
.donutSpinner {
  display: inline-block;
  border: 4px solid #E5EDFF;
  border-left-color: #5850EB;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  animation: donut-spin 1.2s linear infinite;
}

@keyframes donut-spin {
  to {
    transform: rotate(1turn);
  }
}
</style>
